import * as types from './mutation_types';

export default {
    [types.UID](state, uid) {
        state.uid = uid;
    },
    [types.SESSION_ID](state, sessionId) {
        state.sessionId = sessionId;
    },
    [types.ERROR_STATE](state, errorState) {
        state.errorState = errorState;
    },
    [types.IS_AUTH](state, isAuth) {
        state.isAuth = isAuth;
    },
    [types.MENUS](state, menus) {
        state.menus = menus;
    },
    [types.MY_PAGES](state, myPages) {
        state.myPages = myPages;
    },
    [types.LOCALE](state, locale) {
        state.locale = locale;
    },
    [types.PARAMS](state, params) {
        state.params = params;
    },
    [types.POPUP_PARAMS](state, popupParams) {
        state.popupParams = popupParams;
    },
    [types.REG_PARAMS](state, regParams) {
        state.regParams = regParams;
    },
    [types.TOKEN](state, token) {
        state.token = token;
    },
    [types.CORP_CD](state, corpCd) {
        state.corpCd = corpCd;
    },
    [types.ROLES](state, roles) {
        state.roles = roles;
    },
    [types.DEPT_NO](state, deptNo) {
        state.deptNo = deptNo;
    },
    [types.DEPT_LEVEL_CD](state, deptLevelCd) {
        state.deptLevelCd = deptLevelCd;
    },
    [types.LOGIN_NO](state, loginNo) {
        state.loginNo = loginNo;
    },
    [types.LOGIN_RHQ](state, loginRhq) {
        state.loginRhq = loginRhq;
    },
    [types.LOGIN_SYSTEM](state, loginSystem) {
        state.loginSystem = loginSystem;
    },
    [types.SUPER_USER_YN](state, superUserYn) {
        state.superUserYn = superUserYn;
    },
    [types.SUPPORT_SNB](state, supportSnb) {
        state.supportSnb = supportSnb;
    },
    [types.SUPPORT_SNB_PARAMS](state, supportSnbParams) {
        state.supportSnbParams = supportSnbParams;
    },
    [types.CONN_SYSTEM](state, connSystem) {
        state.connSystem = connSystem;
    },
    [types.RETURN_SYSTEM](state, returnSystem) {
        state.returnSystem = returnSystem;
    },
    [types.LOGIN_ID](state, loginId) {
        state.loginId = loginId;
    },
    [types.COUNTRY_CD](state, countryCd) {
        state.countryCd = countryCd;
    },
    [types.COUNTRY_NM](state, countryNm) {
        state.countryNm = countryNm;
    },
    [types.CORP_NO](state, corpNo) {
        state.corpNo = corpNo;
    },
    [types.CORP_NM](state, corpNm) {
        state.corpNm = corpNm;
    },
    [types.COMPANY_NO](state, companyNo) {
        state.companyNo = companyNo;
    },
    [types.JOIN_DATE](state, joinDate) {
        state.joinDate = joinDate;
    },
    [types.LAST_LOGIN](state, lastLogin) {
        state.lastLogin = lastLogin;
    },
    [types.LANG_CD](state, langCd) {
        state.langCd = langCd;
    },
    [types.GUID](state, guid) {
        state.guid = guid;
    },
    [types.EMAIL](state, email) {
        state.email = email;
    },
    [types.LOGIN_COUNTRY_CD](state, loginCountryCd) {
        state.loginCountryCd = loginCountryCd;
    },
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js